import type { SVGProps } from 'react'

export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 199 80"
    width={199}
    height={80}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#FABD1F"
        d="M19.394 62.095v6.653a9.695 9.695 0 0 1-16.686 7.115 9.7 9.7 0 0 1-2.691-7.115V52.405a9.696 9.696 0 0 0 9.697 9.697z"
      />
      <path
        fill="#0FBAAE"
        d="M109.239 19.643v48.814a9.7 9.7 0 0 1-2.691 7.115 9.7 9.7 0 0 1-10.802 2.207 9.7 9.7 0 0 1-5.884-9.322V19.643zM63.265 31.231a30.92 30.92 0 0 1-16.923 27.544 30.7 30.7 0 0 1-13.352 3.32H19.394v-9.696a9.696 9.696 0 0 0-9.128-9.673h25.58a8.04 8.04 0 0 0 5.684-2.3l.027-.027a12.946 12.946 0 0 0 0-18.315l-.027-.027a7.66 7.66 0 0 0-5.417-2.2H9.673A9.675 9.675 0 0 1 0 10.18v-.027A9.67 9.67 0 0 1 9.674.481h25.463a30.88 30.88 0 0 1 28.128 30.76z"
      />
      <path
        fill="#FABD1F"
        d="M169.882 57.444a9.7 9.7 0 0 1-14.27 8.551 9.7 9.7 0 0 1-4.705-11.369 9.695 9.695 0 0 1 16.14-4.033 9.66 9.66 0 0 1 2.835 6.851"
      />
      <path
        fill="#078E80"
        d="M19.394 52.389v9.696H9.697A9.7 9.7 0 0 1 0 52.389v-.017a9.81 9.81 0 0 1 4.407-8.105 9.63 9.63 0 0 1 5.29-1.55h.559a9.697 9.697 0 0 1 9.138 9.672"
      />
      <path
        fill="#F749A1"
        d="M19.394 31.231A9.695 9.695 0 0 1 7.8 40.74a9.7 9.7 0 0 1-7.799-9.506 9.695 9.695 0 0 1 19.393-.002"
      />
      <path
        fill="#FABD1F"
        d="M99.549.264A9.697 9.697 0 0 0 89.85 9.96v9.696H70.293a9.697 9.697 0 1 1 0-19.392z"
      />
      <path
        fill="#FF7A27"
        d="M109.239 9.957v9.696H89.862V9.957A9.694 9.694 0 0 1 99.55-.142a9.7 9.7 0 0 1 6.998 2.984 9.7 9.7 0 0 1 2.691 7.115"
      />
      <path
        fill="#FABD1F"
        d="M138.497 9.957a9.7 9.7 0 0 1-9.697 9.696h-19.561V9.957A9.7 9.7 0 0 0 99.542.26H128.8a9.7 9.7 0 0 1 9.697 9.696"
      />
      <path
        fill="#0FBAAE"
        d="m160.195 31.763-20.397 41.82a9.7 9.7 0 0 1-5.532 5.259 9.7 9.7 0 0 1-12.616-6.148 9.7 9.7 0 0 1 .733-7.597L151.474 5.44c.041-.08.077-.157.121-.238a9.7 9.7 0 0 0-.121 8.733z"
      />
      <path
        fill="#F749A1"
        d="M199 69.34a9.698 9.698 0 0 1-18.391 4.256l-20.414-41.833 8.694-17.84a9.6 9.6 0 0 0 .993-4.227 9.7 9.7 0 0 0-.98-4.256l29.112 59.657A9.6 9.6 0 0 1 199 69.34"
      />
      <path
        fill="#DE0E56"
        d="M169.882 9.696a9.6 9.6 0 0 1-.983 4.24l-8.704 17.827-8.721-17.827a9.7 9.7 0 0 1 .117-8.734 9.7 9.7 0 0 1 13.608-3.794 9.7 9.7 0 0 1 3.57 3.794 9.7 9.7 0 0 1 1.113 4.494"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h199v80H0z" />
      </clipPath>
    </defs>
  </svg>
)
